/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Booleanaspect2Inputs */

const de__class_booleanaspect2 = /** @type {(inputs: _Class_Booleanaspect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist`)
};

/**

* @param {_Class_Booleanaspect2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_booleanaspect2 = /** @type {((inputs?: _Class_Booleanaspect2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Booleanaspect2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_booleanaspect2(inputs)
});
export { _class_booleanaspect2 as "_class_BooleanAspect" }